import { primitive } from '../../../CodesThatsGottaGoSomewhereElse';
import { ComponentType } from '../../../concepts/objects';
import { Physical } from '../entities/Physical';
import { StatePropertyRef } from '../ExtendableStore';


export interface QuickCreateInfo {
    type?: ComponentType<Physical>;
    sets?: Record<string, primitive>;
}

export const QuickCreateInfo = StatePropertyRef<QuickCreateInfo>('quickCreateInfo', {});
